import { ComponentType } from 'react';
import './shared/lib/fontAwesome';

// Anything with an index file under a brand or under shared/ is mountable. The dotted
// name maps 1:1 onto the path, so `Layouts.Full.Footer` is Layouts/Full/Footer — no
// category list to keep in step, and nothing here knows what a "page" is.
const brandModules = import.meta.glob('./brands/*/**/index.{ts,tsx}', { eager: true });
const sharedModules = import.meta.glob('./shared/**/index.{ts,tsx}', { eager: true });

function candidates(name: string, brand: string): string[] {
  const path = name.split('.').join('/');

  return [
    `./brands/${brand}/${path}/index.ts`,
    `./brands/${brand}/${path}/index.tsx`,
    `./shared/${path}/index.ts`,
    `./shared/${path}/index.tsx`,
  ];
}

export function resolveComponent(name: string, brand: string): ComponentType<any> {
  const keys = candidates(name, brand);
  const key = keys.find((k) => k in brandModules || k in sharedModules);

  if (!key) {
    throw new Error(`V2 component not found: ${name} (looked in ${keys.join(', ')})`);
  }

  return ((brandModules[key] ?? sharedModules[key]) as any).default;
}
